module.exports = __webpack_public_path__ + "img/changliang.cbe093c5.png";